import React, { useState, useEffect } from "react";
import { MdErrorOutline } from "react-icons/md";
import "../../assets/css/Modal.css";
const ComplianceStatus = ({ status = "no-data", issues = [], gender }) => {
  const [showModal, setShowModal] = useState(false);

  const normalizedStatus = ["compliant", "non-compliant"].includes(status)
    ? status
    : "no-data";

  const hasIssues = Array.isArray(issues) && issues.length > 0;

  const tagClass =
    normalizedStatus === "compliant"
      ? "tag green"
      : normalizedStatus === "non-compliant"
      ? "tag red"
      : "tag";

  // Close modal when clicking outside or pressing escape
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") {
        setShowModal(false);
      }
    };

    if (showModal) {
      document.addEventListener("keydown", handleEscape);
      document.body.style.overflow = "hidden"; // Prevent background scrolling
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "unset";
    };
  }, [showModal]);

  const handleClick = (e) => {
    e.stopPropagation();
    if (normalizedStatus === "non-compliant" && hasIssues) {
      setShowModal(true);
    }
  };

  return (
    <div>
      <button
        className={tagClass}
        onClick={handleClick}
        title={
          hasIssues ? "Click to view compliance details" : "View compliance"
        }
      >
        {normalizedStatus === "compliant" && "Compliant"}
        {normalizedStatus === "non-compliant" && (
          <>Issues {hasIssues && `(${issues.length})`}</>
        )}
        {normalizedStatus === "no-data" && "No Data"}
      </button>

      {/* Modal popup for compliance issues */}
      {showModal && hasIssues && (
        <>
          <div className="modal-backdrop" onClick={() => setShowModal(false)}>
            <div
              className="compliance-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="compliance-modal-header">
                <div className="modal-header-icon">
                  <MdErrorOutline />
                </div>
                <div className="modal-header-content">
                  <h3>Compliance Issues</h3>
                  <p className="modal-header-subtitle">
                    {issues.length} issue{issues.length !== 1 ? "s" : ""} found
                  </p>
                </div>
              </div>
              <div className="compliance-modal-body">
                <div className="space-y-3">
                  {issues.map((issue, idx) => (
                    <div key={idx} className="compliance-issue">
                      <div className="compliance-items">
                        <p className="compliance-issue-text">{issue}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="compliance-modal-actions">
                <button
                  className="button secondary"
                  onClick={() => setShowModal(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ComplianceStatus;
